<template>
    <div >
        <portlet :clase="'container col-md-12'">
            <template slot="actions">
                <a class="btn btn-circle btn-icon-only btn-success" :href="link_download + '/' + range.start.toISOString().slice(0,10) + '/' + range.end.toISOString().slice(0,10)" target="_blank" title='Descarga de la Bitácora base de datos' ><i class="fa fa-file-excel-o"></i></a>
            </template>
            <template slot="caption">
                <div class="row"> 
                <div class='col-md-6'>          
                    <span class="caption-subject bold uppercase"><i class="fa fa-search"></i> Filtros</span>          
                </div> 
                </div>  
            </template>
            <template slot="caption2">
                <div class="row">	
                    <div class="col-md-3 col-ms-12">
                    <div class="form-group">
                        <label >Rango de Fechas</label>
                        <v-date-picker v-model="range" is-range >
                            <template v-slot="{ inputValue, inputEvents }">
                                <div class="flex justify-center items-center input-group" >
                                <span class='input-group-addon'>De</span>
                                <input :value="inputValue.start" v-on="inputEvents.start" class="form-control  rounded border rounded"/>
                                <span class='input-group-addon'>A</span>
                                <input :value="inputValue.end" v-on="inputEvents.end" class="form-control  rounded border rounded green" />
                                </div>
                            </template>
                        </v-date-picker> 
                    </div>
                </div>
                <div class="col-md-3 col-ms-12" >
                    <span class="help-block">&nbsp;</span>
                    <button type="button" class="btn green enableBtn" id="btnbuscar" v-on:click="loadTableSample()" >Buscar</button>
                </div>            
                </div> 
            </template>
        </portlet>
      <portlet :clase="'container col-md-12 blockui_sample_3_2_element'" > 
        <template slot="actions">
        </template>
        <template slot="caption">
          <div class="row"> 
            <div class='col-md-6'>          
                <span class="caption-subject bold uppercase"> 
                    <i class="fa fa-database"></i> Administracion de base de datos 
                    &nbsp;<a class="btn btn-circle btn-icon-only btn-default" title='Recargar registros' v-on:click="loadTableSample()"><i class="fa fa-rotate-left"></i></a>
                </span>         
            </div>      
          </div>  
        </template>      
        <template slot="body">         
          <div class="row">           
            <tableSample :lengthMenu="lengthMenu" @detalle="editarRegistro" @eliminar="editarRegistro"  :data_="data_" :id="'sample_2'" v-if="renderTable"/>  
          </div>
        </template>
      </portlet>
     
      <modal :id="'portlet-edit'" :modal="'modal-lg'">      
        <template slot="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" v-on:click="limpiarInputs()"></button>
            <h4 class="modal-title"><i class="fa fa-cogs"></i> Administración de base de datos</h4>
        </template>
        <template slot="modal-body">
            <div class="row">
                <portlet :clase="'container col-md-12 blockui_sample_3_2_element'" > 
                    <template slot="tools">
                        <a href="" class="collapse" data-original-title="" title=""></a>
                    </template>
                    <template slot="caption">
                        <h4><strong>Datos Generales</strong></h4>
                    </template>
                    <template slot="body">
                        <div class="row">
                        </div>                            
                    </template>
                </portlet>
            </div>
        </template>
        <template slot="modal-footer">
          <button type="button" data-dismiss="modal" class="btn default" v-on:click="limpiarInputs()">Cerrar</button>
        </template>
      </modal>
    </div>
  </template>  
  <script>
  import axios from 'axios'
  import select2 from './General/Select.vue'
  import portlet from './General/Portlet.vue'
  import modal from './General/Modal.vue'
  import tableSample from './Individual/TableMaquinasBitacora.vue'
  import VCalendar from 'v-calendar'
  export default {
    name: 'ReporteEstadistica',
    components: {axios,select2,portlet,modal,tableSample,VCalendar},
    data(){
        return{
            lengthMenu:[[10, 25, 50, -1],[10, 25, 50, 'All']],
            options:[],
            data_:[],
            id_registro:'',
            range: {
                start:this.firtsDate(),
                end: new Date(),
            },
            renderTable:false,
            inputDisable:false,
            link_download:`${process.env.APP_URL}/download-bitacora-maquinas`,
            rfc_valid:''
        }
    },
    methods:{
        handleFileUpload(event){
            this.file = event.target.files[0];
        },
        loadTableSample(){
            this.renderTable = false 
            this.loagingC(true);
            this.data_=[];                  
            axios.post(`${process.env.APP_URL}/bitacora-maquinas`,{ 
                incio: new Date(this.range.start).toISOString().slice(0,10),
                fin: new Date(this.range.end).toISOString().slice(0,10),})
                .then((response)=>{
                    this.data_=response.data.response;
                    this.renderTable = true
                    this.loagingC(false);
                })
                .catch(error=>{
                    console.log(error);                    
                    this.loagingC(false);                    
                });
        },
        editarRegistro(dato){

        },
        limpiarInputs(){
            this.id_registro='';
        },
        firtsDate(){
            var date = new Date();
            var primerDia = new Date(date.getFullYear(), date.getMonth(), 1);
            return primerDia
        },
        loagingC(value, index, values) {
            return Vue.filter('loadingCharge')(value);
        },
        notifications(Code,Message){
            if(Code=="200"){
                Command: toastr.success(Message, "Notifications");
            }else{
                Command: toastr.warning(Message, "Notifications");
            }
        }
    },
    mounted() {
        this.loadTableSample();
    }
  }
  </script>